class FaqsPage extends HTMLElement {
  connectedCallback() {
    this.filterToggle = this.querySelector('[data-faqs-filter-toggle]');
    this.filterMenu = this.querySelector('[data-faqs-filter-menu]');
    this.filterLabel = this.querySelector('[data-faqs-filter-label]');
    this.groups = this.querySelectorAll('[data-faqs-group]');

    this.filterToggle?.addEventListener('click', this.onFilterToggle.bind(this));
    this.querySelectorAll('[data-faqs-filter-option]').forEach((option) => {
      option.addEventListener('click', this.onFilterSelect.bind(this));
    });

    this.querySelectorAll('[data-faqs-question]').forEach((button) => {
      button.addEventListener('click', this.onQuestionToggle.bind(this));
    });

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick.bind(this));
  }

  onFilterToggle(event) {
    event.stopPropagation();
    const isOpen = this.filterMenu?.classList.toggle('is-open');
    this.filterToggle?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  onFilterSelect(event) {
    const option = event.currentTarget;
    const filterValue = option.dataset.faqsFilterOption;
    const filterText = option.textContent.trim();

    if (option.classList.contains('is-active')) {
      this.closeFilterMenu();
      return;
    }

    this.querySelectorAll('[data-faqs-filter-option]').forEach((item) => {
      item.classList.toggle('is-active', item === option);
    });

    if (this.filterLabel) {
      this.filterLabel.textContent = filterText;
    }

    this.groups.forEach((group) => {
      if (!filterValue) {
        group.classList.remove('is-hidden');
        return;
      }

      group.classList.toggle('is-hidden', group.id !== filterValue);
    });

    this.closeFilterMenu();
  }

  onQuestionToggle(event) {
    const button = event.currentTarget;
    const item = button.closest('[data-faqs-item]');
    const answer = item?.querySelector('[data-faqs-answer]');
    const isOpen = item?.classList.toggle('is-open');

    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (answer && isOpen) {
      answer.style.setProperty('--faqs-answer-height', `${answer.scrollHeight}px`);
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeFilterMenu();
    }
  }

  closeFilterMenu() {
    this.filterMenu?.classList.remove('is-open');
    this.filterToggle?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('faqs-page')) {
  customElements.define('faqs-page', FaqsPage);
}
